import { render, staticRenderFns } from "./DmCarForm.vue?vue&type=template&id=5d1b938d&scoped=true"
import script from "./DmCarForm.vue?vue&type=script&lang=js"
export * from "./DmCarForm.vue?vue&type=script&lang=js"
import style0 from "./DmCarForm.vue?vue&type=style&index=0&id=5d1b938d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b938d",
  null
  
)

export default component.exports